import React from 'react';
import { Prefecture, FormErrors } from '../types';

interface BasicInfoSectionProps {
  formData: Prefecture;
  setFormData: (data: Prefecture) => void;
  errors: FormErrors;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  formData,
  setFormData,
  errors,
}) => {
  const handleChange = (field: keyof Prefecture, value: string | number) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          都道府県名 <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${errors.name ? 'is-invalid' : ''}`}
          id="name"
          value={formData.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
        {errors.name && <div className="invalid-feedback">{errors.name.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="code" className="form-label">
          コード <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${errors.code ? 'is-invalid' : ''}`}
          id="code"
          value={formData.code || ''}
          onChange={(e) => handleChange('code', e.target.value)}
          required
        />
        <small className="form-text text-muted">都道府県を識別するためのコード（例: 01, 13, 27）</small>
        {errors.code && <div className="invalid-feedback">{errors.code.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="sort_order" className="form-label">
          並び順 <span className="text-danger">*</span>
        </label>
        <input
          type="number"
          className={`form-control ${errors.sort_order ? 'is-invalid' : ''}`}
          id="sort_order"
          min="0"
          value={formData.sort_order || 0}
          onChange={(e) => handleChange('sort_order', parseInt(e.target.value, 10) || 0)}
          required
        />
        <small className="form-text text-muted">表示順序を指定（数値が小さいほど上に表示）</small>
        {errors.sort_order && <div className="invalid-feedback">{errors.sort_order.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="slug" className="form-label">
          スラッグ
        </label>
        <input
          type="text"
          className={`form-control ${errors.slug ? 'is-invalid' : ''}`}
          id="slug"
          value={formData.slug || ''}
          onChange={(e) => handleChange('slug', e.target.value)}
        />
        {errors.slug && <div className="invalid-feedback">{errors.slug.join(', ')}</div>}
      </div>
    </div>
  );
};

export default BasicInfoSection;

